import React, { useState } from 'react';
import MarketingLayout from '../components/MarketingLayout';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';
import { API } from '../App';
import '../marketing.css';

const ClubsPage = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);
    const clubName = formData.get('club_name');
    const email = formData.get('email');
    const description = formData.get('club_description');

    try {
      await axios.post(`${API}/cta/submit`, {
        submission_type: 'club',
        name: clubName,
        email: email,
        description: description
      });

      toast.success("Thank you! We'll be in touch soon.");
      e.target.reset();
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
      console.error('CTA submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MarketingLayout>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Turn Your Volunteers' Time into <span className="highlight">Real Revenue</span>
            </h1>
            <p className="hero-subtitle">
              100% free platform for sports clubs, community groups, and charities. Verify volunteer hours and unlock corporate funding.
            </p>
          </div>
        </div>
      </section>

      {/* Why Join Section */}
      <section className="how-it-works" id="how-it-works">
        <div className="container">
          <h2 className="section-title">Why Join PlayBack Token?</h2>
          <p className="section-subtitle">A completely free platform that helps you monetise your volunteer dedication</p>
          
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-card-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/hnbh6mjj_download.jpg" alt="Young soccer player" />
              </div>
              <h3>100% Free</h3>
              <p>No setup fees, no monthly costs, no commissions. Completely free for all clubs and organisations.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/rjonawf5_trainingpowershot169.jpg" alt="Sports training equipment" />
              </div>
              <h3>New Revenue Stream</h3>
              <p>Turn verified volunteer hours into corporate funding which was out of reach up to now. Your volunteers' time becomes tangible value, which you can spend on new equipment, jerseys, or whatever you decide.</p>
            </div>
            
            <div className="benefit-card">
              <div className="benefit-card-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/6hom09rt_community-group.jpg" alt="Community group team" />
              </div>
              <h3>Powerful Analytics</h3>
              <p>Track volunteer hours, see trends, and demonstrate your community impact with detailed reports.</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works for Clubs */}
      <section className="why-matters">
        <div className="container">
          <h2 className="section-title">How It Works for Your Club</h2>
          
          <div className="steps">
            <div className="step">
              <div className="step-large-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/xweee4ys_download%20%283%29.jpg" alt="Person working on laptop" />
              </div>
              <h3>1. Contact Us to Join</h3>
              <p>Fill out the form below or email us. We'll set up your club profile and provide unique signup links.</p>
            </div>
            
            <div className="step">
              <div className="step-large-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/ya7gwo6d_Screenshot%202025-11-04%20170630.jpg" alt="Hand holding smartphone with volunteer logging app" />
              </div>
              <h3>2. Volunteers Log Hours</h3>
              <p>Your volunteers use the app to log their time. Supervisors approve with one click. Verified hours are converted into Tokens.</p>
            </div>
            
            <div className="step">
              <div className="step-large-image">
                <img src="https://customer-assets.emergentagent.com/job_esg-token-platform/artifacts/kxur1rql_cricket%20equipment.jpg" alt="Cricket equipment" />
              </div>
              <h3>3. Receive Funding</h3>
              <p>Large Companies buy your Tokens as part of their Community Impact Budget. Money goes directly into your club bank account. You decide how to spend it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="who-its-for">
        <div className="container">
          <h2 className="section-title">Perfect For</h2>
          
          <div className="audience-grid">
            <div className="audience-card">
              <div className="audience-image">
                <img src="https://customer-assets.emergentagent.com/job_impact-tokens/artifacts/kebt5mp0_download%20%281%29.jpg" alt="Youth hurling training" />
              </div>
              <h3>Sports Clubs</h3>
              <p>Cricket, soccer, rugby, athletics, GAA, and all sports clubs with volunteer coaches, groundskeepers, and administrators.</p>
            </div>
            
            <div className="audience-card">
              <div className="audience-image">
                <img src="https://images.pexels.com/photos/9037596/pexels-photo-9037596.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Community volunteers" />
              </div>
              <h3>Community Groups</h3>
              <p>Residents associations, youth groups, cultural organisations running on volunteer power.</p>
            </div>
            
            <div className="audience-card">
              <div className="audience-image">
                <img src="https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Charity volunteers" />
              </div>
              <h3>Charities</h3>
              <p>Non-profits and charitable organisations that rely on volunteers to deliver their mission.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Call to Action */}
      {/* CTA Section */}
      <section className="cta-section" id="contact">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Join?</h2>
            <p>Contact us to get your club onboarded - it's completely free</p>
            <form className="email-form" id="emailForm" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '600px', margin: '0 auto' }}>
              <input type="text" name="club_name" placeholder="Your club name" required />
              <input type="email" name="email" placeholder="Your email address" required />
              <textarea 
                name="club_description" 
                placeholder="Describe your club (max 50 words)" 
                required 
                maxLength="350"
                rows="3"
                style={{
                  padding: '14px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                  color: '#1f2937',
                  background: 'white'
                }}
                onInput={(e) => {
                  const words = e.target.value.trim().split(/\s+/).filter(word => word.length > 0);
                  if (words.length > 50) {
                    e.target.value = words.slice(0, 50).join(' ');
                  }
                }}
              />
              <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%' }}>
                {loading ? 'Sending...' : 'Request Access'}
              </button>
            </form>
            <p className="privacy-note">Free forever. No credit card required.</p>
          </div>
        </div>
      </section>

      <section className="faq-cta-section">
        <div className="container">
          <div className="faq-cta-content">
            <h2>Have Questions?</h2>
            <p>Find answers to common questions about how PlayBack Token works for clubs</p>
            <Link to="/clubs-faq" className="btn btn-large btn-outline">View Clubs FAQ</Link>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default ClubsPage;
